"use client";

import { PART_COUNT } from "@/lib/game/parts";
import { GameMenuTile } from "../game-ui";
import { MenuScreenShell } from "../MenuScreenShell";
import { useGame } from "../GameProvider";

const MENU_ITEMS = [
  {
    id: "builder" as const,
    icon: "build" as const,
    title: "Build",
    subtitle: "Drag parts onto your rocket!",
    tone: "sky" as const,
    ready: true,
  },
  {
    id: "activities" as const,
    icon: "play" as const,
    title: "Play",
    subtitle: "Earn stars from games",
    tone: "emerald" as const,
    ready: true,
  },
  {
    id: "star-shop" as const,
    icon: "shop" as const,
    title: "Star Shop",
    subtitle: "Buy rocket parts with stars",
    tone: "amber" as const,
    ready: true,
  },
  {
    id: "profile" as const,
    icon: "profile" as const,
    title: "My Progress",
    subtitle: "Stats, unlocks, and reset",
    tone: "indigo" as const,
    ready: true,
  },
];

export function HomeScreen() {
  const { goTo, progress } = useGame();
  const unlockedCount = progress.unlockedPartIds.length;

  return (
    <MenuScreenShell variant="home">
      <div className="flex min-h-0 flex-1 flex-col items-center overflow-y-auto px-5 py-8">
        <header className="shrink-0 text-center">
          <p className="text-4xl" aria-hidden>
            🌟
          </p>
          <h1 className="mt-2 text-3xl font-extrabold tracking-tight text-white drop-shadow-sm sm:text-4xl">
            Rocket Builder
          </h1>
          <p className="mt-2 max-w-sm text-base text-violet-100/90">
            Learn, play, and build your own rocket!
          </p>
          <p className="mt-2 text-lg font-extrabold text-amber-300 drop-shadow">
            {progress.starBalance} ⭐
          </p>
          <p className="mt-1 text-sm font-medium text-sky-200/90">
            {unlockedCount} of {PART_COUNT} parts unlocked
          </p>
        </header>

        <nav
          className="mt-8 grid w-full max-w-md grid-cols-2 gap-3"
          aria-label="Main menu"
        >
          {MENU_ITEMS.map((item) => (
            <GameMenuTile
              key={item.id}
              icon={item.icon}
              label={item.title}
              subtitle={item.subtitle}
              tone={item.tone}
              disabled={!item.ready}
              onClick={() => item.ready && goTo(item.id)}
            />
          ))}
        </nav>
      </div>
    </MenuScreenShell>
  );
}
